/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { ListOrganizationsQueryResponse } from "../../types/organizationController/ListOrganizations.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listOrganizations } from "../../client/organizationController/listOrganizations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listOrganizationsQueryKey = () => [{ url: '/api/organizations/' }] as const

export type ListOrganizationsQueryKey = ReturnType<typeof listOrganizationsQueryKey>

export function listOrganizationsQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = listOrganizationsQueryKey()
  return queryOptions<ListOrganizationsQueryResponse, ResponseErrorConfig<Error>, ListOrganizationsQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return listOrganizations(config)
   },
  })
}

/**
 * @summary List organizations for current user
 * {@link /api/organizations/}
 */
export function useListOrganizations<TData = ListOrganizationsQueryResponse, TQueryData = ListOrganizationsQueryResponse, TQueryKey extends QueryKey = ListOrganizationsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ListOrganizationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? listOrganizationsQueryKey()

  const query = useQuery({
   ...listOrganizationsQueryOptions(config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}